import { BrowserRouter, Routes, Route } from "react-router";
import { AuthProvider } from "@/lib/auth-context";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { LoginForm } from "@/components/auth/LoginForm";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { CLIAuthPage } from "@/components/auth/CLIAuthPage";
import { TokenAuthPage } from "@/components/auth/TokenAuthPage";
import { AppLayout } from "@/components/layout/AppLayout";
import { NotFound } from "@/components/layout/NotFound";
import { QuestionnairePage } from "@/components/onboarding/QuestionnairePage";
import { ReferralCapture } from "@/components/referral/ReferralCapture";
import { ReferralPage } from "@/components/referral/ReferralPage";
import { HomePage } from "@/components/home/HomePage";
import { WorkspacesPage } from "@/components/workspaces/WorkspacesPage";
import { WorkspaceLayout } from "@/components/workspace/WorkspaceLayout";
import { AccountPage } from "@/components/account/AccountPage";
import { AffiliatePage } from "@/components/affiliate/AffiliatePage";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/cli-auth" element={<CLIAuthPage />} />
          <Route path="/token-auth" element={<TokenAuthPage />} />
          <Route path="/ref/:code" element={<ReferralCapture />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
          <Route element={<AuthGuard />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<WorkspacesPage />} />
              <Route path="/@:username" element={<WorkspacesPage />} />
              <Route path="/workspace/:id" element={<WorkspaceLayout />} />
              <Route path="/affiliate" element={<AffiliatePage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
